import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { API } from "../context/AuthContext";
import Seo from "../components/Seo";
import { useLanguage } from "../context/LanguageContext";

export default function ForgotPassword() {
  const { t } = useLanguage();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      toast.error(t("Errore. Riprova più tardi."));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[70vh] max-w-[520px] mx-auto px-6 py-24">
      <Seo title="Password dimenticata" path="/forgot-password" noindex />
      {sent ? (
        <div className="text-center">
          <div className="overline text-[#8C3A3A]">{t("Controlla la tua email")}</div>
          <h1 className="font-serif text-4xl tracking-tighter mt-2">{t("Ti abbiamo scritto.")}</h1>
          <p className="mt-4 text-stone-600">
            {t("Se ")}<span className="font-mono">{email}</span>{t(" è registrata su Rarium, entro pochi minuti riceverai un'email con il link per reimpostare la password.")}
          </p>
          <Link to="/login" data-testid="forgot-back-login" className="mt-8 inline-block text-xs uppercase tracking-widest font-semibold bg-stone-900 hover:bg-[#8C3A3A] text-stone-50 px-8 py-4 transition-colors">{t("Torna al login")}</Link>
        </div>
      ) : (
        <form onSubmit={submit}>
          <div className="overline text-stone-500">{t("Recupero accesso")}</div>
          <h1 className="font-serif text-4xl tracking-tighter mt-2">{t("Password dimenticata?")}</h1>
          <p className="mt-4 text-stone-600 text-sm">{t("Inserisci la tua email e ti manderemo un link per reimpostarla.")}</p>
          <label className="mt-8 flex flex-col">
            <span className="overline text-stone-500 mb-2">Email</span>
            <input
              data-testid="forgot-email"
              type="email"
              required
              value={email}
              onChange={e => setEmail(e.target.value)}
              className="border-b border-stone-300 bg-transparent py-3 focus:border-stone-900 focus:outline-none"
            />
          </label>
          <button data-testid="forgot-submit" disabled={busy} className="mt-8 w-full text-xs uppercase tracking-widest font-semibold bg-stone-900 hover:bg-[#8C3A3A] text-stone-50 px-8 py-4 transition-colors disabled:opacity-50">{busy ? "…" : t("Invia link di recupero")}</button>
          <div className="mt-6 text-sm text-stone-600 text-center">
            {t("Ti sei ricordato?")} <Link to="/login" className="underline-hover text-[#8C3A3A]">{t("Torna al login")}</Link>
          </div>
        </form>
      )}
    </div>
  );
}
